export enum MasterAccountAccessErrorTypeEnum {
	APPLICATION_EXISTS = "APPLICATION_EXISTS"
}

